import getApiInstance from 'data/common/ApiCallGenerique';
/** @var Logger Logger */
import Translator from 'translator';
import { Logger, Toastr } from 'data/common';
import api from './api';
/** @var ApiCall apiCaller */
const apiCaller = getApiInstance();

function getInstallers() {
    return dispatch => {
        return apiCaller
            .call(api.getAllInstallers())
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__INIT_INSTALLERS',
                        installers: data.installers
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setFheInstallers - ', error);
                throw new Error('installers_have_not_been_correctly_returned_by_server');
            });
    };
}
function getInstallerDetails(installerId) {
    return dispatch => {
        return apiCaller
            .call(api.getInstallerDetails(installerId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__SET_INSTALLERDETAILS',
                        installer: data.installerDetails
                    });
                    return data;
                } else throw new Error('installers_details_have_not_been_correctly_returned_by_server');
            })
            .catch(error => {
                Logger.log('dataActions: setFHEInstallerDetails - ', error);
                throw error;
            });
    };
}

function updateInstallerDetails(installerId, installerForm) {
    return dispatch => {
        return apiCaller
            .call(api.updateInstallerDetails(installerId, installerForm))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__UPDATE_INSTALLER',
                        installer: data.installer
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: updateFHEInstallerDetails - ', error);
                throw error;
            });
    };
}

function addInstaller(installerForm) {
    return dispatch => {
        return apiCaller
            .call(api.addInstaller(installerForm))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__ADD_INSTALLER',
                        installer: data.installer,
                        installerId: data.installerId
                    });
                    if (data.intermediateError) {
                        Logger.warn('dataActions: addFHEInstaller - ', data.intermediateError);
                        Toastr.warning(
                            Translator.translateWithFallback(
                                `api.message.${data.intermediateError.response ? data.intermediateError.response : data.intermediateError.message}`,
                                'api.message.default'
                            ),
                            Translator.translate('api.message.intermediate_error')
                        );
                    }
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: addFHEInstaller - ', error);
                throw error;
            });
    };
}

function resetPassword(installerId, installerForm) {
    return () => {
        return apiCaller
            .call(api.resetPassword(installerId, installerForm))
            .then(({ data }) => {
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setFHEResetPassword - ', error);
                throw error;
            });
    };
}

export { getInstallers, getInstallerDetails, updateInstallerDetails, resetPassword, addInstaller };



// WEBPACK FOOTER //
// ./environments/fhe/data/Installers/actions.js